(function () {
  var section = document.querySelector('.faq-section');
  if (!section) return;

  var singleOpen = section.dataset.singleOpen === 'true';

  section.addEventListener('click', function (e) {
    var summary = e.target.closest('summary');
    if (!summary) return;
    var details = summary.closest('details');
    var wrapper = details && details.querySelector('.faq-section__content-wrapper');
    if (!details || !wrapper) return;

    e.preventDefault();
    var open = !details.classList.contains('is-open');

    if (open) {
      function openThis() {
        details.setAttribute('open', '');
        wrapper.offsetHeight;
        details.classList.add('is-open');
        summary.setAttribute('aria-expanded', 'true');
      }
      if (singleOpen) {
        var other = section.querySelector('details.is-open');
        if (other && other !== details) {
          var otherWrapper = other.querySelector('.faq-section__content-wrapper');
          var otherSummary = other.querySelector('summary');
          other.classList.remove('is-open');
          if (otherSummary) otherSummary.setAttribute('aria-expanded', 'false');
          if (otherWrapper) {
            otherWrapper.addEventListener('transitionend', function () {
              other.removeAttribute('open');
              openThis();
            }, { once: true });
          } else {
            other.removeAttribute('open');
            openThis();
          }
          return;
        }
      }
      openThis();
    } else {
      details.classList.remove('is-open');
      summary.setAttribute('aria-expanded', 'false');
      wrapper.addEventListener('transitionend', function () {
        details.removeAttribute('open');
      }, { once: true });
    }
  });
})();
